import React from 'react'

type SlideOutFooterProps = {
  children: React.ReactNode
  justify?: string
}

export function SlideOutFooter({
  children,
  justify = 'end',
}: SlideOutFooterProps) {
  const footerStyle = `flex justify-${justify} py-4 fixed px-6 bottom-0 right-0 w-full bg-white`
  return <footer className={footerStyle}>{children}</footer>
}
